import React, { createContext, useState } from "react";

// Buat Context
export const LanguageContext = createContext();

// Data bahasa disimpan di luar komponen untuk menghindari duplikasi
const languages = {
  id: {
    1: "Berdiri pada tahun 2012, dengan luas lebih dari 23.000 m², PT. Langgeng Buana Jaya adalah Produsen Peralatan Asli (OEM) terkemuka di dunia untuk produk konsumen. Kami memproduksi beragam produk untuk peritel besar di Amerika Serikat, Eropa, Asia, dan Australia.",
    2: "PT Langgeng Buana Jaya, yang berkantor pusat di Gresik, Indonesia, adalah perusahaan OEM (Original Equipment Manufacturer) ternama yang berspesialisasi dalam produksi produk plastik dan mainan berkualitas tinggi untuk pasar global. Berlokasi di kota Gresik yang dinamis, PT Langgeng Buana Jaya diuntungkan oleh posisi strategisnya di Indonesia, yang memungkinkan akses mudah ke pasar lokal dan internasional. Perusahaan ini bangga dengan fasilitas manufaktur mutakhirnya, yang dilengkapi dengan mesin dan teknologi canggih, memastikan presisi dan efisiensi dalam proses produksi. Setiap produk menjalani pengujian dan langkah-langkah kontrol kualitas yang ketat untuk memastikan hanya produk terbaik yang mencapai pasar. Dengan mematuhi standar dan peraturan internasional, perusahaan telah membangun reputasi untuk menghasilkan produk yang aman dan andal yang melampaui harapan pelanggan. PT Langgeng Buana Jaya menekankan pada perekrutan penduduk lokal yang tinggal di dekat perusahaan. Dengan memprioritaskan keterlibatan individu dari masyarakat sekitar, perusahaan tidak hanya mendukung ekonomi lokal tetapi juga menumbuhkan rasa memiliki yang kuat dan integrasi komunitas di antara para karyawannya. Silakan hubungi kami untuk portofolio produksi dan harga kompetitif kami.",
    3: "Kami menerapkan prinsip Keberagaman dan Inklusi serta Nilai-nilai Perusahaan kami yaitu Keselamatan, Integritas, Komitmen, Rasa Hormat, dan Keunggulan dalam setiap proses perekrutan, agar sejalan dengan Prinsip Perilaku Bisnis (PBC) dan kebijakan perusahaan lainnya.",
    4: "Tantangan Kami",
    5: "Peluang Anda",
    6: "Karir Bersama Kami",
    7: "Experienced Professional",
    8: "Intership Program",
    9: "Karyawan",
    10: "Departemen",
    11: "Klien",
    12: "ACARA KAMI",
    13: "Acara Terbaru",
    14: "Menu",
    15: "Event",
    16: "Karir",
    17: "Tentang Kami",
    18: "Tentang LBJ",
    19: "Tentang",
    20: "Beranda"
  },
  en: {
    1: "Established in 2012, Stands above 23,000 M2 area, PT. Langgeng Buana Jaya is a leading Original Equipment Manufacturer (OEM) in consumer products around the world. We produce a wide range of products for major retailers in the United States, Europe, Asia and Australia.",
    2: "PT Langgeng Buana Jaya, based in Gresik, Indonesia, is a renowned OEM (Original Equipment Manufacturer) enterprise that specializes in the production of high-quality plastic products and toys for the global market. Located in the vibrant city of Gresik, PT Langgeng Buana Jaya benefits from its strategic position in Indonesia, which allows for convenient access to both local and international markets. The company takes pride in its state-of-the-art manufacturing facilities, equipped with advanced machinery and technology, ensuring precision and efficiency in the production process. Each product undergoes rigorous testing and quality control measures to ensure that only the finest products reach the market. By adhering to international standards and regulations, the company has earned a reputation for producing safe and reliable products that exceed customer expectations. PT Langgeng Buana Jaya emphasizes on employing local people living in close proximity to the company. By prioritizing the engagement of individuals from the surrounding community, the company not only supports the local economy but also fosters a strong sense of belonging and community integration among its workforce. Please contact us for our production portfolio and our competitive pricing.",
    3: "We apply the principles of Diversity and Inclusion as well as our Company Values of Safety, Integrity, Commitment, Respect, and Excellence in every recruitment process, to be in line with our Principles of Business Conduct (PBC) and other company policies.",
    4: "Our Challenges",
    5: "Your Opportunities",
    6: "Career With Us",
    7: "Experienced Professional",
    8: "Intership Program",
    9: "Employee",
    10: "Department",
    11: "Client",
    12: "OUR EVENT",
    13: "Latest Event",
    14: "Menu",
    15: "Event",
    16: "Career",
    17: "About Us",
    18: "About LBJ",
    19: "About",
    20: "Home"
  },
  chi: {
    1: "PT. Langgeng Buana Jaya 成立於2012年，佔地超過23,000平方米，是全球領先的消費品原始設備製造商 (OEM)。我們為美國、歐洲、亞洲和澳洲的主要零售商生產各種產品。",
    2: "PT Langgeng Buana Jaya总部位于印度尼西亚的Gresik，是一家著名的OEM（原始设备制造商）企业，专门生产高质量的塑料制品和玩具，面向全球市场。公司位于充满活力的Gresik市，得益于其在印度尼西亚的战略位置，能够方便地进入本地和国际市场。公司以其先进的制造设施为傲，配备了先进的机械和技术，确保生产过程中的精确性和效率。每件产品都经过严格的测试和质量控制措施，以确保只有最优质的产品能够进入市场。通过遵守国际标准和法规，公司赢得了生产安全可靠产品、超出客户期望的声誉。PT Langgeng Buana Jaya强调雇佣居住在公司附近的当地人。通过优先考虑周边社区成员的参与，公司不仅支持当地经济，还在员工中培养了强烈的归属感和社区融合感。请联系我们获取我们的产品组合和有竞争力的价格。",
    3: "我们在每一个招聘过程中都应用多样性和包容性的原则，以及我们的公司价值观：安全、诚信、承诺、尊重和卓越，以符合我们的商业行为准则（PBC）和其他公司政策。",
    4: "我们的挑战",
    5: "您的机会",
    6: "与我们一起职业发展",
    7: "经验丰富的专业人士",
    8: "实习计划",
    9: "员工",
    10: "部门",
    11: "客户",
    12: "我们的活动",
    13: "最新活动",
    14: "菜单",
    15: "活动",
    16: "职业",
    17: "关于我们",
    18: "关于 LBJ",
    19: "关于",
    20: "主页"
  },
};

// Provider untuk menyediakan state bahasa ke komponen lain
export const LanguageProvider = ({ children }) => {
  // Inisialisasi state bahasa berdasarkan localStorage
  const [currentLanguage, setCurrentLanguage] = useState(
    // Jika tidak ada preferensi di localStorage, default ke "id" (bahasa Indonesia)
    localStorage.getItem("currentLanguage") || "id"
  );

  // Fungsi untuk memperbarui bahasa
  const toggleLanguage = (newLanguage) => {
    // Simpan preferensi bahasa ke localStorage
    localStorage.setItem("currentLanguage", newLanguage);
    setCurrentLanguage(newLanguage);
  };

  // Gunakan data bahasa yang sesuai berdasarkan state `currentLanguage`
  const language = languages[currentLanguage] || languages.id;

  return (
    <LanguageContext.Provider
      value={{ language, toggleLanguage, currentLanguage }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
